/**
 * Transforma um número de processo para o seguinte formato `'000.000/0000'`.
 *
 * @param nrProcesso Número de processo
 * @returns Número formatado,
 *   retorna o próprio parâmetro `nrProcesso` quando inválido
 */
export function formatarNrProcesso(nrProcesso: string) {
  return nrProcesso?.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1.$2/$3');
}
